import React from 'react';
import './RequestQuoteInput.scss';
import { TextInput } from './form-components/input';

const RequestQuoteAdditionalInformationInput = ({ errors, touched, formik }) => (
  <form className="request-quote-input">
    <TextInput
      name="additionalInformation"
      placeholder="Additional information"
      errors={errors.additionalInformation}
      touched={touched.additionalInformation}
      isTextArea
      isInputWhite
      dataSal=""
      formik={formik}
    />
  </form>
);

export default RequestQuoteAdditionalInformationInput;
